import React from 'react';
import { Datagrid, TextField, usePermissions, TextInput, Filter, SelectInput } from 'react-admin';
import { List } from '~/layout';
import RoleCreate from './RoleCreate';
import { makeStyles } from '@material-ui/core/styles';
import {} from '~/components';
import { BooleanField } from 'react-admin';

const l = (key: string): string => `resources.roles.fields.${key}`;
const d = (key: string): string => `utils.${key}`;

const RoleList = (props: any) => {
  const { permissions } = usePermissions();
  const classes = useStyles();
  if (!permissions) return null;
  return (
    <List
      {...props}
      bulkActionButtons={false}
      actions={<RoleCreate permissions={permissions} />}
      filters={
        <Filter className={classes.form}>
          <TextInput
            label={l('id')}
            source='id'
            alwaysOn
            style={{ minWidth: 120 }}
            className={classes.formControl}
          />
          <TextInput
            label={l('name')}
            source='name'
            alwaysOn
            style={{ minWidth: 180 }}
            className={classes.formControl}
          />
          <SelectInput
            label={l('readonly')}
            source='readonly'
            alwaysOn
            choices={[
              { id: true, name: d('yes') },
              { id: false, name: d('no') },
            ]}
            emptyText={d('any')}
            className={classes.formControl}
          />
        </Filter>
      }
    >
      <Datagrid rowClick='show' size='medium' selectedIds={null}>
        <TextField source='id' label={l('id')} />
        <TextField source='name' label={l('name')} x />
        <BooleanField source='readonly' label={l('readonly')} addLabel={false} nullOnFalse />
      </Datagrid>
    </List>
  );
};

const useStyles = makeStyles((theme) => ({
  form: {
    '& > div': {
      '& > div:last-child': {
        width: theme.spacing(1),
      },
    },
  },
  formControl: {
    width: 200,
  },
}));

export default RoleList;
